import {
  Badge,
  Button,
  Col,
  DatePicker,
  Divider,
  Input,
  Row,
  Select,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { COLORS } from "../../constants/Colors";
import Typography from "../Typography";
import { FormattedMessage, useIntl } from "react-intl";
import _ from "lodash";
import Button_02 from "../Button_02";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import "../filter.css";

const FilterQueue = (props) => {
  const {
    handleFilterShipment,
    shipmentStatus,
    handleApply,
    handleReset,
    queueuFilter,
  } = props;
  const intl = useIntl();
  const { Option } = Select;
  const format = "DD/MM/YYYY";
  const isDesktop = useIsDesktop();
  const lang = localStorage.getItem('lang')
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        borderRadius: "0px 0px 8px 8px",
        width: "100%",
        backgroundColor: "#F8F8F8",
      }}
    >
      <div className="d-flex flex-column justify-content-center text-left w-100">
        <Row>
        <Col span={isDesktop ? 8 : 24}>
            <Typography
              className="py-3 px-4"
              isBold
              color={ isDesktop ? COLORS.DarkGray : COLORS.Purple }
              size={"12px"}
            >
              <FormattedMessage
                id="QueuePark"
                defaultMessage="ช่องจอด"
              />
            </Typography>
            <div className="px-4">
              <Input
              className="inputShadow"
                style={{
                  borderRadius: "8px",
                  width: "100%",
                  marginRight: "5px",
                }}
                placeholder={intl.formatMessage({
                  id: "QueueParkSpace",
                  defaultMessage: "ระบุช่องจอด",
                })}
                onChange={(e) =>
                  handleFilterShipment(e.target.value, "parking")
                }
                allowClear
                value={_.get(queueuFilter, "parking")}
              />
            </div>
          </Col>
          {/* ---------------------------------------------------------------------- */}
          <Col span={isDesktop ? 8 : 24}>
            <Typography
              className="py-3 px-4"
              isBold
              color={ isDesktop ? COLORS.DarkGray : COLORS.Purple }
              size={"12px"}
            >
              <FormattedMessage
                id="QueueCustomer"
                defaultMessage="ลูกค้า"
              />
            </Typography>
            <div className="px-4">
              <Input
              className="inputShadow"
                style={{
                  borderRadius: "8px",
                  width: "100%",
                  marginRight: "5px",
                }}
                placeholder={intl.formatMessage({
                  id: "QueueCustomerPH",
                  defaultMessage: "ระบุลูกค้า",
                })}
                onChange={(e) =>
                  handleFilterShipment(e.target.value, "customerName")
                }
                allowClear
                value={_.get(queueuFilter, "customerName")}
              />
            </div>
          </Col>
          {/* ---------------------------------------------------------------------- */}
          <Col span={isDesktop ? 8 : 24}>
            <Typography
              className="py-3 px-4"
              isBold
              color={ isDesktop ? COLORS.DarkGray : COLORS.Purple }
              size={"12px"}
            >
              <FormattedMessage id="StatusParking" defaultMessage="สถานะ" />
            </Typography>
            <div className="px-4">
              <Select
                className="inputShadow"
                style={{
                  borderRadius: "8px",
                  width: "100%",
                  marginRight: "5px",
                }}
                placeholder={intl.formatMessage({
                  id: "StatusParkingPH",
                  defaultMessage: "เลือกสถานะ",
                })}
                onChange={(e) => handleFilterShipment(e, "queueStatus")}
                allowClear
                value={_.get(queueuFilter, "queueStatus")}
              >
                {_.map(shipmentStatus, (item, index) => (
                  <Option key={_.get(item, "statusFlowCode")} value={_.get(item, "statusFlowCode")}>
                    {lang === 'TH' ? _.get(item, "txt.TH") : _.get(item, 'txt.EN')}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
        {/* ********************************************************************** */}
        <Row style={{ marginTop: "10px" }}>
          <Col span={isDesktop ? 8 : 24}>
            <Typography
              className="py-3 px-4"
              isBold
              color={ isDesktop ? COLORS.DarkGray : COLORS.Purple }
              size={"12px"}
            >
              <FormattedMessage
                id="StartDatingOutParking"
                defaultMessage="วันที่ออกเริ่มต้น"
              />
            </Typography>
            <div className="px-4">
              <DatePicker
                className="inputShadow"
                style={{
                  borderRadius: "8px",
                  width: "100%",
                  marginRight: "5px",
                }}
                placeholder={intl.formatMessage({
                  id: "DatingParkingPH",
                  defaultMessage: "เลือกวันที่",
                })}
                onChange={(e) => handleFilterShipment(e, "fromCreateDateOut")}
                allowClear
                value={_.get(queueuFilter, "fromCreateDateOut")}
                format={format}
              />
            </div>
          </Col>
          {/* ---------------------------------------------------------------------- */}
          <Col span={isDesktop ? 8 : 24}>
            <Typography
              className="py-3 px-4"
              isBold
              color={ isDesktop ? COLORS.DarkGray : COLORS.Purple }
              size={"12px"}
            >
              <FormattedMessage
                id="EndDatingOutParking"
                defaultMessage="วันที่ออกสิ้นสุด"
              />
            </Typography>
            <div className="px-4">
              <DatePicker
                className="inputShadow"
                style={{
                  borderRadius: "8px",
                  width: "100%",
                  marginRight: "5px",
                }}
                placeholder={intl.formatMessage({
                  id: "DatingParkingPH",
                  defaultMessage: "เลือกวันที่",
                })}
                onChange={(e) => handleFilterShipment(e, "toCreateDateOut")}
                allowClear
                value={_.get(queueuFilter, "toCreateDateOut")}
                format={format}
              />
            </div>
          </Col>
          {/* ---------------------------------------------------------------------- */}
          {isDesktop ? (
            <Col
              span={isDesktop ? 8 : 24}
              style={{ paddingTop: isDesktop ? "35px" : "0px" }}
            >
              <div className="py-3 px-4" style={{ textAlign: "end" }}>
                <Button_02
                  style={{ margin: "0px 10px 0px 10px",color: COLORS.Primary ,border: `1px solid ${COLORS.Primary} `  }}
                  key="back"
                  btnsize="wd_df"
                  onClick={handleReset}
                >
                  <FormattedMessage
                    id="btnResetFilterReset"
                    defaultMessage="Reset"
                  />
                </Button_02>

                <Button
                  style={{
                    backgroundColor: COLORS.Primary,
                    width: "100px",
                    height: "32px",
                  }}
                  type="primary"
                  onClick={handleApply}
                >
                  <FormattedMessage
                    id="filterApplyButton"
                    defaultMessage="Search"
                  />
                </Button>
              </div>
            </Col>
          ) : (
            <>
              <Col
                span={24}
                style={{ paddingTop: isDesktop ? "35px" : "10px" }}
              >
                <div className="py-3 px-4" style={{ textAlign: "end" }}>
                  <Button
                    style={{
                      backgroundColor: COLORS.Primary,
                      width: "100%",
                      height: "32px",
                    }}
                    type="primary"
                    onClick={handleApply}
                  >
                    <FormattedMessage
                      id="filterApplyButton"
                      defaultMessage="Search"
                    />
                  </Button>
                </div>
              </Col>
              <Col
                span={24}
                style={{ paddingTop: "0px", paddingBottom: "24px" }}
              >
                <div className="py-1 px-4" style={{ textAlign: "end" }}>
                  <Button_02
                    style={{ margin: "0px 0px 0px 0px", width: "100%" }}
                    key="back"
                    btnsize="wd_df"
                    onClick={handleReset}
                  >
                    <FormattedMessage
                      id="btnResetFilterReset"
                      defaultMessage="Reset"
                    />
                  </Button_02>
                </div>
              </Col>
            </>
          )}
        </Row>
      </div>
    </div>
  );
};

export default FilterQueue;
